/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const readEventRequestV4Schema = z.object({
  eventId: z
    .string()
    .nullish()
    .describe('Coded id of the clicked event (a me/getUserEvents item id).')
    .meta({ examples: ['kJ8v2Qm7xR1a'] }),
})
